/** Hostels are boys-only or girls-only — no mixed dormitories. */
export const HOSTEL_GENDERS = ["Boys", "Girls"];

export function normalizeHostelGender(value) {
    const v = String(value || "").trim();
    if (HOSTEL_GENDERS.includes(v)) return v;
    return null;
}

export function studentGenderToHostelGender(studentGender) {
    const g = String(studentGender || "").trim().toLowerCase();
    if (g === "male" || g === "boy" || g === "m") return "Boys";
    if (g === "female" || g === "girl" || g === "f") return "Girls";
    return null;
}

export function studentMatchesHostel(studentGender, hostelGender) {
    const required = studentGenderToHostelGender(studentGender);
    const hostel = normalizeHostelGender(hostelGender);
    if (!hostel) {
        return {
            ok: false,
            message:
                "This hostel must be set to Boys or Girls before boarders can be assigned.",
        };
    }
    if (!required) {
        return {
            ok: false,
            message: "Select the student's gender (Male or Female) before choosing a hostel.",
        };
    }
    if (required !== hostel) {
        const who = required === "Boys" ? "Boys" : "Girls";
        const where = hostel === "Boys" ? "boys'" : "girls'";
        return {
            ok: false,
            message: `${who} cannot be assigned to a ${where} hostel.`,
        };
    }
    return { ok: true };
}

export function filterHostelsForStudentGender(hostels, studentGender) {
    const required = studentGenderToHostelGender(studentGender);
    if (!required) return [];
    return (hostels || []).filter((h) => normalizeHostelGender(h.gender) === required);
}

/** Default form value when editing legacy Mixed hostels. */
export function hostelGenderFormValue(value) {
    return normalizeHostelGender(value) || "Boys";
}
